import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Package, Plus, Search, Edit, Eye, Tag, ShoppingCart } from "lucide-react";
import { useState } from "react";

const VendorProducts = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-lg bg-[#E5DEFF]">
            <Package className="h-6 w-6 text-[#8B5CF6]" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-[#222222]">Products</h1>
        </div>
        <Button className="bg-[#8B5CF6] hover:bg-[#7E69AB] gap-3">
          <Plus className="h-4 w-4" />
          Add New Product
        </Button>
      </div>

      <div className="grid gap-6">
        <Card className="p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between mb-8">
            <div className="relative w-full md:w-72">
              <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
              <Input
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
              />
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-500">
              <ShoppingCart className="h-4 w-4" />
              <span>Total Products: 2</span>
            </div>
          </div>

          <div className="rounded-lg border border-gray-100 overflow-hidden">
            <Table>
              <TableHeader className="bg-[#F1F0FB]">
                <TableRow>
                  <TableHead className="font-semibold py-4">Product Name</TableHead>
                  <TableHead className="font-semibold">Price</TableHead>
                  <TableHead className="font-semibold">Stock</TableHead>
                  <TableHead className="font-semibold">Sales</TableHead>
                  <TableHead className="font-semibold text-right">Action</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow className="hover:bg-[#F8F7FF] transition-colors">
                  <TableCell className="font-medium py-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded bg-[#FDE1D3] flex items-center justify-center">
                        <Tag className="h-5 w-5 text-[#F97316]" />
                      </div>
                      <div className="space-y-1">
                        <p className="font-semibold">Electronics Package</p>
                        <p className="text-sm text-gray-500">#PROD001</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="text-[#0EA5E9] font-semibold">$1,200</TableCell>
                  <TableCell>
                    <span className="px-3 py-1.5 rounded-full bg-green-100 text-green-700 text-sm">
                      15 in stock
                    </span>
                  </TableCell>
                  <TableCell>45</TableCell>
                  <TableCell>
                    <div className="flex justify-end gap-3">
                      <Button variant="ghost" size="sm" className="h-9 w-9">
                        <Eye className="h-4 w-4 text-gray-500" />
                      </Button>
                      <Button variant="ghost" size="sm" className="h-9 w-9">
                        <Edit className="h-4 w-4 text-gray-500" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow className="hover:bg-[#F8F7FF] transition-colors">
                  <TableCell className="font-medium py-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded bg-[#D3E4FD] flex items-center justify-center">
                        <Tag className="h-5 w-5 text-[#0EA5E9]" />
                      </div>
                      <div className="space-y-1">
                        <p className="font-semibold">Home Appliances Set</p>
                        <p className="text-sm text-gray-500">#PROD002</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell className="text-[#0EA5E9] font-semibold">$2,500</TableCell>
                  <TableCell>
                    <span className="px-3 py-1.5 rounded-full bg-yellow-100 text-yellow-700 text-sm">
                      8 in stock
                    </span>
                  </TableCell>
                  <TableCell>32</TableCell>
                  <TableCell>
                    <div className="flex justify-end gap-3">
                      <Button variant="ghost" size="sm" className="h-9 w-9">
                        <Eye className="h-4 w-4 text-gray-500" />
                      </Button>
                      <Button variant="ghost" size="sm" className="h-9 w-9">
                        <Edit className="h-4 w-4 text-gray-500" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default VendorProducts;